import "../Styles/Faq.css";

function Faq({ faq }) {
  return (
    <div className="FirstPart" id="faq">
      <div className="left faqIntro">
        <h2>{faq.title}</h2>
        <p>{faq.subtitle}</p>
      </div>

      <div className="right">
        {faq.items.map((item) => (
          <details key={item.id} className="detail">
            <summary>{item.q}</summary>
            <p>{item.a}</p>
          </details>
        ))}
      </div>
    </div>
  );
}

export default Faq;
